export default function makeSlicer<P>(): <K extends keyof P>(key: K) => (root: Pick<P, K>) => P[K] {
	return <K extends keyof P>(key: K): ((root: Pick<P, K>) => P[K]) =>
		(root): P[K] =>
			root[key];
}
